module.exports = __webpack_public_path__ + "static/conferencia-f9ddc9690a2b9bea9e2f0109b97c8cdb.jpg";